import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { formatedDate, fullName, isOwner } from "./../../constants/function";
import moment from "moment";
import { Images } from "./../../assets/common";
import { useTranslation } from "react-i18next";
export default function TransactionRow({
  transaction,
  name,
  amount,
  credit,
  status,
}) {
  const { t } = useTranslation("common");
  const transactionType = (type, isOwner, transaction) => {
    switch (type) {
      case "subscription":
        return t("transactionRow.text1");
      case "tip":
        return isOwner ? t("transactionRow.text2") : t("transactionRow.text3");
      case "purchase":
        return isOwner ? t("transactionRow.text4") : t("transactionRow.text5");
      case "nft":
        return isOwner
          ? ""
          : `${t("transactionRow.text6")}(${
              transaction["currency"] ? transaction["currency"] : ""
            })`;
      case "sikiBalanceTransfer":
        return isOwner ? t("tokenPurchased") : t("tokenPurchased");
      case "royalty":
        return transaction["royaltyType"]
          ? `${t("transactionRow.text7")}  ${transaction["royaltyType"]}(${
              transaction["assetName"]
            }):`
          : t("transactionRow.text8");
      default:
        return "";
    }
  };
  return (
    <Box
      sx={{
        borderBottom: "1px solid #262626",

        marginTop: "10px !important",
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ marginBottom: "10px !important", marginTop: "10px !imporant" }}
      >
        <Box
          sx={{
            width: "44px",
            height: "44px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            backgroundColor:
              transaction["type"] !== "tip" &&
              transaction["type"] !== "subscription" &&
              transaction["type"] !== "royalty" &&
              transaction["type"] !== "purchase" &&
              transaction["type"] !== "sikiBalanceTransfer" &&
              transaction["type"] !== "nft"
                ? "#FFEE20"
                : "transpatant",
            marginRight: "12px",
          }}
        >
          {transaction["type"] === "subscription" ? (
            <img className="w100" src={Images.subscription} alt="s" />
          ) : transaction["type"] === "tip" &&
            transaction["currency"] === "siki" ? (
            <img className="w100" src={Images.tip_player} alt="siki" />
          ) : transaction["type"] === "tip" &&
            transaction["currency"] === "hbar" ? (
            <img className="w100" src={Images.hbar_1} alt="hbar" />
          ) : transaction["type"] === "tip" &&
            transaction["currency"] === "matic" ? (
            <img className="__polygon_img" src={Images.polygon} alt="siki" />
          ) : transaction["type"] === "tip" && !transaction["currency"] ? (
            <img className="w100" src={Images.tip_player} alt="siki" />
          ) : transaction["type"] === "royalty" ? (
            <img className="w100" src={Images.tip_player} alt="s" />
          ) : transaction["type"] === "purchase" &&
            transaction["currency"] &&
            transaction["currency"] === "siki" ? (
            <img className="w100" src={Images.tip_player} alt="s" />
          ) : transaction["type"] === "purchase" &&
            transaction["currency"] &&
            transaction["currency"] === "hbar" ? (
            <img className="w100" src={Images.hbar_1} alt="s" />
          ) : transaction["type"] === "purchase" &&
            transaction["currency"] &&
            transaction["currency"] === "matic" ? (
            <img className="__polygon_img" src={Images.polygon} alt="s" />
          ) : transaction["type"] === "purchase" && !transaction["currency"] ? (
            <Typography color="default">
              {fullName(transaction["toUser"]).charAt(0)}
            </Typography>
          ) : transaction["type"] === "sikiBalanceTransfer" &&
            transaction["currency"] &&
            transaction["currency"] === "hbar" ? (
            <img className="w100" src={Images.hbar_1} alt="s" />
          ) : transaction["type"] === "sikiBalanceTransfer" &&
            transaction["currency"] &&
            transaction["currency"] === "siki" ? (
            <img className="w100" src={Images.tip_player} alt="s" />
          ) : transaction["type"] === "sikiBalanceTransfer" &&
            transaction["currency"] &&
            transaction["currency"] === "matic" ? (
            <img className="__polygon_img" src={Images.polygon} alt="s" />
          ) : transaction["type"] === "nft" ? (
            <img className="w100" src={Images.NFT} alt="nft" />
          ) : transaction["type"] === "sikiBalanceTransfer" &&
            !transaction["currency"] ? (
            <Typography color="default">
              {fullName(transaction["toUser"]).charAt(0)}
            </Typography>
          ) : (
            <Typography color="default">
              {fullName(transaction["toUser"]).charAt(0)}
            </Typography>
          )}
        </Box>
        <Box sx={{ marginRight: "auto" }}>
          <Typography variant="body1">
            {transactionType(
              transaction["type"],
              isOwner(transaction["toUser"]["email"]),
              transaction
            )}
          </Typography>
          <Typography variant="body1">
            {isOwner(transaction["fromUser"]["email"])
              ? fullName(transaction["toUser"])
              : transaction["type"] === "purchase"
              ? fullName(transaction["fromUser"])
              : fullName(transaction["fromUser"])}
          </Typography>
          <Typography variant="body2" className="fade-text">
            {formatedDate(transaction["createdDate"])}
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{ textAlign: "right" }}
            className={
              isOwner(transaction["toUser"]["email"]) ? "success" : "error"
            }
          >
            {isOwner(transaction["toUser"]["email"])
              ? "+" + transaction["amount"].toFixed(3)
              : "-" + transaction["amount"].toFixed(3)}
          </Typography>
          {transaction["status"] !== "approved" ? (
            <Typography
              sx={{ textAlign: "right" }}
              variant="body2"
              className={
                "fs-13 " +
                (transaction["status"] === "Pending" ||
                transaction["status"] === "Failed"
                  ? "other"
                  : transaction["status"] === "Cancelled"
                  ? "canceled"
                  : "error")
              }
            >
              {transaction["status"]}
            </Typography>
          ) : null}
        </Box>
      </Stack>
    </Box>
  );
}
